export default {
  route: {
    dashboard: 'Dashboard',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    i18n: 'I18n',
    storeInfo: 'Store Info',
    shopProduct: 'Shop Product',
    account: 'Account',
    reservation: 'Reservation',
    reservationOrder: 'Reservation Order',
    orderTrack: 'Order Track',
    orderDetail: 'Order Detail',
    orderRecord: 'Order Record',
    editOrder: 'Edit Order',
    createOrder: 'Create Order',
    orderEvaluation: 'Order Evaluation',
    productManagement: 'Product Management',
    productCategory: 'Product Category',
    skuManagement: 'Sku Management',
    serviceManagement: 'Service Management',
    performanceMethod: 'Performance Method',
    promotionManagement: 'Promotion Management',
    orderReduction: 'Order Reduction',
    partner: 'Partner',
    serviceMall: 'Service Mall',
    orderManagement: 'Order Management',
    mallAddCountry: 'Add Country',
    activity: 'Activity',
    activityList: 'Activity List',
    uploadImage: 'Upload Image',
    productList: 'Product List'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人中心',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: 'Carlcare商户管理后台',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  table: {
    dynamicTips1: '固定表头, 按照表头顺序排序',
    dynamicTips2: '不固定表头, 按照点击顺序排序',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    import: '导入',
    importPic: '导入图片',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 定',
    on: '上架',
    off: '下架',
    enable: '启用',
    abolish: '废除',
    modify: '编辑'
  },
  example: {
    warning: '创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  zip: {
    export: '导出',
    placeholder: '请输入文件名(默认file)'
  },
  pdf: {
    tips: '这里使用   window.print() 来实现下载pdf的功能'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  shopInfo: {
    country: '国家',
    state: '州',
    city: '城市',
    partnerCode: '商户编码',
    partnerName: '商户名称',
    partnerPhone: '商户电话',
    storeCode: '店铺编号',
    storeType: '门店类型',
    storeName: '名称',
    address: '地址',
    lI: '经纬度',
    phone: '联系方式',
    ownerName: '店主名',
    workTime: '营业时间（选填）',
    rate: '评分',
    level: '级别（选填）',
    restDate: '休息日（选填）',
    import: '导入',
    aspCode: 'CRM系统编码',
    brand: 'Brand',
    status: 'Status',
    reserve: 'Reserve'
  },
  shopProduct: {
    partnerCode: '商户编码',
    storeCode: '店铺编号',
    storeName: '店铺名称',
    service: '服务范围',
    product: '商品范围',
    performance: '履约范围',
    status: '营业状态',
    configure: 'configure',
    all: 'All',
    clear: 'clear',
    firstClass: 'First Classification',
    secondClass: 'Second Classification',
    thirdClass: 'Third Classification',
    quality: 'Quality',
    brandModel: 'Brand&Model',
    brand: 'Brand',
    model: 'Model',
    productCode: 'Product Code',
    productName: 'Product Name',
    price: 'price'
  },
  shopAccount: {
    owner: '使用人',
    phone: '联系方式',
    partnerCode: '商家编码',
    storeCode: '店铺编码',
    account: '账户',
    password: '密码',
    add: 'Add'
  },
  order: {
    source: 'Source',
    channel: 'Channel',
    account: 'Account',
    orderNumber: 'Order Number',
    storeCode: 'Store Code',
    resDate: 'Reservation Date',
    time: 'Time',
    customerName: 'Customer Name',
    phone: 'Phone Number',
    status: 'Status',
    contact: 'Contact',
    evaluation: 'Evaluation',
    add: 'Add',
    createTime: 'Create Time',
    country: 'Country',
    serviceStore: 'Servcie Store',
    model: 'Device Model',
    des: 'Fault Description',
    remark: 'Remark',
    latestTime: 'Latest DS Time',
    dsResult: 'DS Result',
    detail: 'Details',
    cancel: 'Cancel',
    acceptionTime: 'Acception Time',
    receptionTime: 'Reception Time',
    callCode: 'Call Code',
    repairedPhone: 'Repaired Phone',
    faultAnalysis: 'Fault Analysis',
    serviceDetails: 'Service Details',
    serviceType: 'Service Type',
    price: 'Price',
    discount: 'Discount',
    payment: 'Payment',
    finishTime: 'Finish Time',
    pickUpTime: 'Pick-up TIme',
    feedbackTime: 'Feedback Time',
    enviroment: 'Enviroment',
    attitude: 'Attitude',
    efficiency: 'Efficiency',
    repairQuality: 'Repair Quality',
    serviceScore: 'Service Score',
    serviceEvaluation: 'Service Evaluation',
    submit: 'Submit',
    choose: 'Choose',
    record: 'Record',
    productType: 'Product Type',
    quality: 'Quality',
    deviceModel: 'Device Model',
    productFeatures: 'Product Features',
    type: 'Type',
    applicableModel: 'Applicable Model',
    productCode: 'Product Code',
    color: 'Color',
    productName: 'Product Name',
    specification: 'Specification',
    serviceLevel: 'Service Level',
    serviceMothod: 'Service Mothod',
    servcieStore: 'Servcie Store',
    reservationTime: 'Reservation Time',
    phoneNumber: 'Phone Number',
    customerRemark: 'Customer Remark',
    paymentMethod: 'Payment Method',
    payStatus: 'Pay Status'
  },
  productCategory: {
    firstClass: '一级分类',
    firstClassCode: '一级分类编码',
    secondClass: '二级分类',
    secondClassCode: '二级分类编码',
    thirdClass: '三级分类',
    thirdClassCode: '三级分类编码'
  },
  skuManagement: {
    spec: '商品规格',
    businessType: '业务类型',
    remarks: '备注',
    price: '物料价格',
    prodCode: '物料编码',
    prodName: '物料名称',
    brand: '品牌',
    model: '机型',
    color: '颜色',
    appBrand: '适用品牌',
    appModel: '适用机型',
    prodFeatures: '产品特性'
  },
  serviceManagement: {
    price: '服务价格',
    prodCode: '服务编码',
    prodName: '服务名称',
    serviceLevel: '维修等级'
  },
  performanceMethod: {
    price: '履约方式价格',
    prodCode: '履约方式编码',
    prodName: '履约方式名称'
  },
  prodManage: {
    material: '物料名称',
    service: '服务名称',
    performanceMethod: '履约方式名称',
    picture: '商品图片',
    desc: '商品描述',
    detail: '商品详情图片',
    disPrice: '折扣价',
    inventory: '库存'
  },
  orderReduction: {
    promoteName: '活动名称',
    deductAmount: '减免金额',
    validTime: '生效时间',
    promoteRange: '范围',
    priority: '优先级',
    overlay: '是否重叠',
    operator: '操作人',
    createTime: '创建时间',
    updateTime: '更新时间'
  },
  orderEvaluation: {
    show: '显示',
    hide: '隐藏',
    account: '账号',
    orderNumber: '预约订单号',
    servcieStore: '网点名称',
    customerName: '顾客姓名',
    phoneNumber: '顾客手机号',
    feedbackTime: '反馈时间',
    enviroment: '服务环境评分',
    attitude: '服务态度评分',
    efficiency: '服务效率评分',
    repairQuality: '服务质量评分',
    servcieScore: '服务综合分数',
    serviceEvaluation: '反馈和建议',
    startDate: '开始日期',
    endDate: '结束日期'
  },
  promoteManage: {
    title: 'Title',
    banner: 'Banner',
    url: 'URL',
    product: 'Product',
    prodName: 'Product Name',
    detail: 'Detail',
    condition: 'Condition',
    excPrice: 'Exclusive Price',
    activityUrl: 'Activity Url'
  }
};